import requestProvider from "./axiosHandler";

const getAllNonShippingOrder = () => {

    return requestProvider
        .get('/outgoing/non-shipping-order')
}

const createOutgoing = (list) => {

    return requestProvider
        .post('/outgoing', list)
}

const getOutgoingShippingOrder = (pageNo, pageSize) => {

    return requestProvider
        .get(`/outgoing/so-paginated/${pageNo}/${pageSize}`)
}

const completedShippingOrder = (id) => {

    return requestProvider
        .post(`/outgoing/completed/${id}`, )
}

const waitingShippingOrder = (id) => {

    return requestProvider
        .post(`/outgoing/waiting/${id}`)
}

const consignmentCompleted = (id) => {
    return requestProvider
        .post(`/outgoing/consignment-completed/${id}`)
}

const revertConsignmentCompleted = (id) => {
    return requestProvider
        .post(`/outgoing/consignment-not-completed/${id}`)
}

const dispatchOutgoing = (id) => {
    return requestProvider
        .post(`/outgoing/completed-shipping-order/${id}`)
};

const getOutgingsNonShippingWithPage = (pageNo = 0, pageSize = 10) => {
    return requestProvider
        .get(`/outgoing/non-so-paginated/${pageNo}/${pageSize}`)
};

const getOutgoingShippingWithPage = (list) => {
    return requestProvider
        .post('/outgoing/so-detail-filter', list);
};

export {
    getAllNonShippingOrder,
    dispatchOutgoing,
    createOutgoing,
    getOutgoingShippingOrder,
    completedShippingOrder,
    waitingShippingOrder,
    consignmentCompleted,
    revertConsignmentCompleted,
    getOutgingsNonShippingWithPage,
    getOutgoingShippingWithPage
}